import React from "react";

import renovation from './../renovation.jpg';
import electricite from './../electricite.jpg';
import decoration from './../decoration.jpg';
import neuf from './../neuf.jpg';
import salleDeBain from './../salleDeBain.jpg';
import placoIsolation from './../placoIsolation.jpg';
import cuisine from './../cuisine.jpg';
import consultation from './../consultation.png';
import extension from './../extension.jpg';
import plomberie from './../plomberie.jpg';
import carrelage from './../carrelage.jpg';
import peinture from './../peinture.jpg';
import sablage from './../sablage.jpg';
import facade from './../facade.jpg';
import './Footer.css'
import Cards from './cards'; // <- Mise à jour ici

const services = [
  {
    title: "Rénovation générale",
    image: renovation,
    description: "Envie de moderniser votre intérieur ? Notre équipe donne vie à vos idées pour transformer vos espaces selon vos envies.",
  },
  {
    title: "Électricité",
    image: electricite,
    description: "Nous assurons une installation électrique fiable, conforme et pensée pour votre confort et vos besoins du quotidien.",
  },
  {
    title: "Décoration",
    image: decoration,
    description: "Murs, sols, agencements : nous vous accompagnons pour sublimer votre intérieur avec un style qui vous ressemble.",
  },
  {
    title: "Neuf",
    image: neuf,
    description: "Vous construisez votre maison ? Confiez-nous l’aménagement intérieur pour un rendu à la hauteur de vos attentes.",
  },
  {
    title: "Salle de bain clé en main",
    image: salleDeBain,
    description: "Besoin de renouveau ? Nous repensons entièrement votre salle de bain pour allier esthétique et fonctionnalité.",
  },
  {
    title: "Placo / Isolation",
    image: placoIsolation,
    description: "Nous intervenons pour améliorer votre confort thermique et phonique avec des solutions de placo et d’isolation performantes.",
  },
  {
    title: "Cuisine",
    image: cuisine,
    description: "Nous installons votre nouvelle cuisine avec soin et précision pour qu’elle devienne un lieu pratique et agréable.",
  },
  {
    title: "Consultation personnalisée",
    image: consultation,
    description: "Bénéficiez de nos conseils experts pour définir et planifier vos projets de rénovation selon vos contraintes et vos envies.",
  },
  {
    title: "Extension / Garage / Grange",
    image: extension,
    description: "Nous redonnons vie à vos espaces supplémentaires : extensions, garages ou granges deviennent des lieux utiles et harmonieux.",
  },
  {
    title: "Plomberie / Sanitaire",
    image: plomberie,
    description: "Nos spécialistes interviennent pour rénover ou installer votre plomberie avec sérieux et qualité.",
  },
  {
    title: "Carrelage / Faïence",
    image: carrelage,
    description: "Du sol au mur, nous posons carrelage et faïence pour un rendu impeccable, moderne ou traditionnel selon votre goût.",
  },
  {
    title: "Peinture",
    image: peinture,
    description: "Apportez une touche de fraîcheur à votre intérieur avec nos prestations de peinture.",
  },
  {
    title: "Ravalement de façade",
    image: facade,
    description: "Nous redonnons un aspect neuf à votre façade grâce à nos travaux de ravalement. Nettoyage, réparation, enduit et peinture pour transformer l'apparence de votre bâtiment.",
  },

];


export const Services = (props) => {
  return (
    <div id="services" className="text-center">
      <div className="">
        <div className="section-title">
          <h2>Nos Services</h2>
          <h3 style={{color:'white',fontSize:'19px'}}>Grâce à notre équipe de professionnels, L'EXPERT RENOVATION
          vous propose divers services.

 

Venez vite les découvrir !</h3>
        </div>
        
     

        <div className="container">
  <div className="row">
    {services.map((d, i) => (
      <div
        key={`${d.title}-${i}`}
        className="col-sm-6 col-md-4"
        style={{ display: "flex", justifyContent: "center", marginBottom: "47px" }}
      >
        <Cards
          title={d.title}
          imageSrc={d.image}
          description={d.description}
        />
      </div>
    ))}
  </div>
</div>

      </div>
    </div>
  );
};
